export default "__VITE_ASSET__f1e8b79b__"